import { render } from "./Cookiebanner.vue?vue&type=template&id=dbb37222&scoped=true"
import script from "./Cookiebanner.vue?vue&type=script&lang=js"
export * from "./Cookiebanner.vue?vue&type=script&lang=js"

import "./Cookiebanner.vue?vue&type=style&index=0&id=dbb37222&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb37222"]])

export default __exports__